import react from 'react';
import DriverFairwayHybridSpec from './ClubSpecByType/DriverFairwayHybridSpec';
import IronSpec from './ClubSpecByType/IronSpec';
import PutterSpec from './ClubSpecByType/PutterSpec';
import Styles from './ClubSpecs.module.scss';

const ClubSpecs = (props) => {
  const { clubItem, getFormattedDate } = props;

  return (
    <div className={Styles.buildSpecs}>
      {clubItem?.product === 'IRONS' && (
        <IronSpec clubItem={clubItem} getFormattedDate={getFormattedDate} />
      )}
      {(clubItem?.product === 'DRIVERS'
        || clubItem?.product === 'HYBRIDS'
        || clubItem?.product === 'FAIRWAYS') && (
        <DriverFairwayHybridSpec
          clubItem={clubItem}
          getFormattedDate={getFormattedDate}
        />
      )}
      {clubItem?.product === 'PUTTERS' && (
        <PutterSpec clubItem={clubItem} getFormattedDate={getFormattedDate} />
      )}
    </div>
  );
};

export default ClubSpecs;
